import { Button } from '@crazyegginc/hatch';

import { useModal } from '/src/hooks';
import { Modal } from '/src/contexts/modal';

import IntroInstantHeatmapsGif from '@crazyegginc/hatch/dist/animations/intro-instant-heatmaps.gif';

import { ReactComponent as HeatIcon } from '@crazyegginc/hatch/dist/images/icon-heat-filled.svg';

export function FirstVisitModal({ onClose = null }) {
  const modal = useModal();

  const handleClose = () => {
    modal.close();
    onClose?.();
  };

  if (window.isE2E) {
    return null;
  }

  return (
    <Modal dialogClassName="!w-[640px] !p-0 overflow-hidden" onDismiss={handleClose}>
      <div className="relative w-full -z-[1]">
        <div className="w-full px-10 pt-10 bg-solitude-500 overflow-hidden">
          <img src={IntroInstantHeatmapsGif} alt="" role="presentation" className="h-full w-full block -mb-32" />
        </div>
        <div className="w-full border-t border-t-mystic-500 p-[30px]">
          <h4 className="flex items-center text-xl font-semibold text-black-pearl-500 mb-2">
            Introducing Instant Heatmaps (100% free)
          </h4>
          <p className="text-sm text-black-pearl-500 leading-tight mb-2">
            Crazy Egg now auto-generates heatmaps for the last 30 days of traffic, on every page. Spot where visitors
            click, so you can prioritize where to create Heatmaps for deeper analysis.
          </p>
          <p className="text-sm text-black-pearl-500 leading-tight mb-6 flex">
            To view the Instant Heatmap for any page, tap the{' '}
            <HeatIcon className="h-4 w-4 fill-current text-california-500 mx-2" />
            next to it.
          </p>
          <Button className="self-start" onClick={handleClose}>
            View Now
          </Button>
        </div>
      </div>
    </Modal>
  );
}
